import React, { useState,useEffect,useCallback } from 'react';
import {MDBBtn, MDBContainer,MDBRow, MDBCol, MDBCard,MDBCardBody,MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import Papa from 'papaparse';
import Tnedata from "../services/data";
import axios from 'axios';
import Header from '../component/layout/header';
import Footer from '../component/layout/footer';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ModalLog from '../component/ModalLog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { BiSkipPrevious, BiSkipNext  } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';

//import { handleDownload, otheraudithandleDownload,exceptionhandleDownload,allaudithandleDownload, passthroughhandleDownload } from '../assets/assets';
const AuditorPage = () => {
  const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const [logdata, setLogdata] = useState()
    const [downdata, setDowndata] = useState(undefined)
    const [currentPage, setCurrentPage] = useState(1);
    const [modalShow, setModalShow] = useState(false);
    const [downlogdata, setDownLogdata] = useState()
    const [fname, setFname] = useState()
    const [downdate, setDowndate] = useState()
    const [Selected, setSelected] = useState(-1);
    const [selectedItem, setSelectedItem] = useState({});
    

    

    const itemsPerPage = 5;
    const totalPages = Math.ceil(logdata ? logdata.length / itemsPerPage :"");
    //console.log(totalPages);

  //Sort order 
    const currentRows = logdata ? logdata.sort((a, b) => new Date(b.upload_date) - new Date(a.upload_date)).slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) :"";
    console.log(currentRows);

  
//   const renderPaginationLinks = () => {
//     const pageLinks = [];
//     for (let i = 1; i <= totalPages; i++) {
//         pageLinks.push(
//             <MDBBtn key={i} onClick={() => changePage(i)}>{i}</MDBBtn>
//         );
//     }
//     return pageLinks;
// };

const renderPaginationLinks = () => {
  const pageLinks = [];

  // Previous Button
  if (currentPage > 1) {
      pageLinks.push(
          <MDBBtn key="prev" onClick={() => changePage(currentPage - 1)}><BiSkipPrevious style={{fontSize: "20px"}} /></MDBBtn>
      );
  }

  // Page Numbers
  const maxPagesToShow = 5; // Adjust this value based on your preference
  const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  for (let i = startPage; i <= endPage; i++) {
      pageLinks.push(
          <MDBBtn key={i} onClick={() => changePage(i)}>{i}</MDBBtn>
      );
  }

  // // Ellipsis
  // if (currentPage < totalPages - Math.floor(maxPagesToShow / 2)) {
  //     pageLinks.push(
  //         <span key="ellipsis" className="ellipsis">...</span>
  //     );
  // }

  // Next Button
  if (currentPage < totalPages) {
      pageLinks.push(
          <MDBBtn key="next" onClick={() => changePage(currentPage + 1)}><BiSkipNext style={{fontSize: "20px"}}  /></MDBBtn>
      );
  }

  return pageLinks;
};
    const changePage = page => {
      setCurrentPage(page);
    };
    //console.log(logdata);
    //console.log(logdata[0].create_at);
    const formatDate = (dateString) => {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    };
    const originalDate = logdata ? logdata.upload_date : ""; // Replace this with your original date string
    const formattedDate = formatDate(originalDate);
    //console.log(formattedDate)

    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${day}/${month}/${year}`;
   
    //Greater_800
    const handleDownload = async(date) => {
      //alert("gt>800")
      //console.log(date)
      const response1 = await Tnedata.greaterthan800_downloadexpense(date);
      setDowndata(response1)
     // console.log(response1)
      //console.log(downdata)
      // Convert the date to mm/dd/yyyy format for the filename
      //console.log(date)
      // console.log(downdata)
      setFname("Greater_800") 
      const fname = "Greater_800";
      await csvExport(response1,fname, date) 

    // if (typeof downdata !=='undefined'){
     // console.log("yes data")
      const user = sessionStorage.getItem('user');
      const downloadjson= [{ download_date : currentDate, download_user : user, download_item : fname, upload_date   : date}]
      const postdownlodlog =  await Tnedata.postdownloadlog(downloadjson)
      await fetchdownloadlog(date)
      //console.log(postdownlodlog);
     //}else{console.log(" ")}
      
    };

    //Other Audit
    const otheraudithandleDownload = async(date) => {
      //alert("otheraudit")
      const response1 = await Tnedata.otheraudit_downloadexpense(date);
      setDowndata(response1);
      //console.log(response1)
      //console.log(downdata)
      // Convert the date to mm/dd/yyyy format for the filename
      // console.log(date)
      // console.log(downdata)
      setFname("Other_Audit") 
      const fname = "Other_Audit";
      await csvExport(response1,fname, date) 
     // if (typeof downdata !=='undefined'){
      //await csvExport(response1,fname, date)
      const user = sessionStorage.getItem('user');
      const downloadjson= [{ download_date : currentDate, download_user : user, download_item : fname, upload_date   : date}]
      const postdownlodlog =  await Tnedata.postdownloadlog(downloadjson)
      await fetchdownloadlog(date)
      //console.log(postdownlodlog);
   // }else{console.log(" ")}
    };

    //exception_download
    const exceptionhandleDownload = async(date) => {
     // alert("exception_download")
      const response1 = await Tnedata.exception_download(date);
      setDowndata(response1)
      //console.log(response1)
      //console.log(downdata)
      // Convert the date to mm/dd/yyyy format for the filename
      // console.log(date)
      // console.log(downdata)
      setFname("Exception") 
      const fname = "Exception";
    //  if (typeof downdata !=='undefined'){
      await csvExport(response1,fname, date)
      const user = sessionStorage.getItem('user');
      const downloadjson= [{ download_date : currentDate, download_user : user, download_item : fname, upload_date   : date}]
      const postdownlodlog =  await Tnedata.postdownloadlog(downloadjson)
      await fetchdownloadlog(date)
      //console.log(postdownlodlog);
   // }else{console.log(" ")}
    };
    
    //allaudit_download
    const allaudithandleDownload = async(date) => {
     // alert("allaudit_download")
      const response1 = await Tnedata.allaudit_download(date);
      setDowndata(response1)
      //console.log(response1)
      //console.log(downdata)
      // Convert the date to mm/dd/yyyy format for the filename
      // console.log(date)
      // console.log(downdata)
      setFname("All Audit") 
      const fname = "All Audit";

     // if (typeof downdata !=='undefined'){
      await csvExport(response1,fname,date)
      const user = sessionStorage.getItem('user');
      const downloadjson= [{ download_date : currentDate, download_user : user, download_item : fname, upload_date   : date}]
      const postdownlodlog =  await Tnedata.postdownloadlog(downloadjson)
      await fetchdownloadlog(date)
      //console.log(postdownlodlog);
   // }else{console.log(" ")}
    };
    //passthrough_download
    const passthroughhandleDownload = async(date) => {
     
      const response1 = await Tnedata.passthrough_download(date);
      setDowndata(response1)
      //console.log(response1)
      //console.log(downdata)
      // Convert the date to mm/dd/yyyy format for the filename
      // console.log(formattedDate)
      // console.log(downdata)
      setFname("Pass Through") 
      //alert("passthrough_download")
      const fname = "Pass Through";

     // if (typeof downdata !=='undefined'){
      await csvExport(response1,fname, date)
      const user = sessionStorage.getItem('user');
      const downloadjson= [{ download_date : currentDate, download_user : user, download_item : fname, upload_date   : date}]
      const postdownlodlog =  await Tnedata.postdownloadlog(downloadjson)
      await fetchdownloadlog(date)
      //console.log(postdownlodlog);
    //}else{console.log(" ")}
    };

    //Rejection

    //passthrough_download
    const rejectionshandleDownload = async(date) => {
     
      const response1 = await Tnedata.rejections_download(date);
      setDowndata(response1)
      //console.log(response1)
      //console.log(downdata)
      // Convert the date to mm/dd/yyyy format for the filename
      // console.log(formattedDate)
      // console.log(downdata)
      setFname("rejections") 
      //alert("passthrough_download")
      const fname = "rejections";

     // if (typeof downdata !=='undefined'){
      await csvExport(response1,fname, date)
      const user = sessionStorage.getItem('user');
      const downloadjson= [{ download_date : currentDate, download_user : user, download_item : fname, upload_date   : date}]
      const postdownlodlog =  await Tnedata.postdownloadlog(downloadjson)
      await fetchdownloadlog(date)
      //console.log(postdownlodlog);
    //}else{console.log(" ")}
    };


  const fetchdownloadlog = async(date) =>{
    const downloadresponse = await Tnedata.getDownloadLog(date)
    const downlog = downloadresponse.data;
    //console.log(downlog)
    let items =[]
    downlog.forEach((doc) => {
      items.unshift(doc)
  });
  
    setDownLogdata(items)
  }

  
//console.log(downlogdata)

    const fetchlog= async (logdata) => {
     const response1 = await Tnedata.getLog();
      const response = await Tnedata.getMetalog();
      if (response ) {
        const log = response.data;
        let logitems =[]
        log.forEach((doc) => {
            logitems.unshift(doc)
        });
        setLogdata(logitems);
      }
    };
    //CSV Export
    const csvExport = async(res,fname, date) =>{
      //Change the json order for excel
      // var csvnew = Papa.unparse({
      //   fields: ["Country (of Employee)", "Org Unit 1 - Code", "Document Header Text/Report ID"],
      //   data: res.data
      // });
      // console.log(csvnew)
      // const formattedDate = formatDate(dateString);
      const csv =  Papa.unparse( res, {header:true}) ;
      // Create a Blob with text content
      const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      // Create a download link
      const url = URL.createObjectURL(csvData);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fname}_data_${date}.csv`; // Set the filename with formatted date
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }

    useEffect(()=>{
      const sessioncode = sessionStorage.getItem("sessioncode");
      console.log(sessioncode);
      if (sessioncode === " ") {
       navigate('/');
      } 
      fetchlog()
      fetchdownloadlog(downdate)
    },[downdate])
//console.log(currentRows)
//console.log(logdata)
console.log(downlogdata)
    return (
  <MDBContainer fluid className='vh-2  p-0 overflow-hidden'>
    <Header></Header>
      <MDBContainer className='pt-4 auditor'>
<MDBRow>
        <div className="col-1"></div>
        <div className="col-12">
        <MDBCard className='mb-5 bg-glass overflow-auto'>
          <MDBCardBody>
              <MDBRow>
                  <MDBCol className='text-start pt-3'><h6>Download File for Audit</h6></MDBCol>
              </MDBRow>
          <MDBTable hover>
            <MDBTableHead>
              <tr>
                <th style={{textAlign:"center"}}>Date of Upload</th>
                <th style={{textAlign:"center"}}>Greater than €800</th>
                <th style={{textAlign:"center"}}>Concur Exceptions</th>
                <th style={{textAlign:"center"}}>Other Audit Targets</th>
                <th  style={{textAlign:"center"}}>Rejections</th>
                <th style={{textAlign:"center"}}>All Audit Targets</th>
                <th style={{textAlign:"center"}}>Pass-through</th>
                <th style={{textAlign:"center"}}>View Logs</th>
                 {/* Add more table headers for additional properties */}
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {currentRows ? currentRows.map((row, index) => (
                <tr key={index} style={{textAlign:"center"}}>
                   <td style={{textAlign:"center"}}>{row.upload_date}</td>
                   <td style={{textAlign:"center"}}><MDBBtn className="downloadbtn" onClick={(e) =>{ e.preventDefault(); handleDownload(row.upload_date) }}>Download</MDBBtn></td>
                   <td style={{textAlign:"center"}}><MDBBtn className="downloadbtn" onClick={(e) =>{ e.preventDefault(); exceptionhandleDownload(row.upload_date) }}>Download</MDBBtn></td>
                   <td style={{textAlign:"center"}}><MDBBtn className="downloadbtn" onClick={(e) =>{ e.preventDefault(); otheraudithandleDownload(row.upload_date) }}>Download</MDBBtn> </td>
                   <td style={{textAlign:"center"}}><MDBBtn className="downloadbtn" onClick={(e) =>{ e.preventDefault(); rejectionshandleDownload(row.upload_date) }}>Download</MDBBtn> </td>
                   <td style={{textAlign:"center"}}><MDBBtn className="downloadbtn" onClick={(e) =>{ e.preventDefault(); allaudithandleDownload(row.upload_date) }}>Download</MDBBtn></td>
                   <td style={{textAlign:"center"}}><MDBBtn className="downloadbtn" onClick={(e) =>{ e.preventDefault(); passthroughhandleDownload(row.upload_date) }} style={{background:"#5bab15"}}>Download</MDBBtn> </td>
                   <td style={{textAlign:"center"}}> <MDBBtn variant="primary" onClick={(e) => { setDowndate(row.upload_date); setModalShow(true);}} ><FontAwesomeIcon icon={faCircleInfo} /></MDBBtn>
                   <ModalLog show={modalShow} onHide={() => setModalShow(false)} upload_date={downdate} downloadlog= {downlogdata}/>
                  </td>
                </tr>
              )) : "Loading..."}
            </MDBTableBody>
          </MDBTable>
          <div className="pagination">
          {/* <MDBBtn disabled={currentPage === 1} onClick={() => changePage(currentPage - 1)}><BiSkipPrevious style={{fontSize: "20px"}} /></MDBBtn> */}
           {renderPaginationLinks()}
          {/* <MDBBtn disabled={currentPage === totalPages} onClick={() => changePage(currentPage + 1)}><BiSkipNext style={{fontSize: "20px"}}  /></MDBBtn> */}

          {/* {Array.from({ length: totalPages }, (_, index) => (
              <MDBBtn key={index + 1} onClick={() => changePage(index + 1)}>
                {index + 1}
              </MDBBtn>
            ))}  */}
          </div>
          </MDBCardBody>
          </MDBCard>
        </div>
        <div className="col-1"></div>
       </MDBRow>
      </MDBContainer>  
      <Footer/>
  </MDBContainer>
    );
  };
export default AuditorPage;